import React, { useEffect } from "react";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { Bugsnag } from "@services";
import { Box, Text, Image, Button } from "@atoms";
import { AnnouncementModalFragment } from "./__generated__/AnnouncementModalFragment";
import {
  DismissAnnouncementMutation,
  DismissAnnouncementMutationVariables,
} from "./__generated__/DismissAnnouncementMutation";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  announcement: AnnouncementModalFragment;
}

// == Constants ============================================================

// variables not fully utilized yet.
// ctaDestination
// youtubeId
AnnouncementModal.fragments = gql`
  fragment AnnouncementModalFragment on Announcement {
    id
    ctaText
    ctaUrl
    description
    image {
      large
    }
    title
  }
`;

const DISMISS_ANNOUNCEMENT_MUTATION = gql`
  mutation DismissAnnouncementMutation($id: ID!) {
    DismissAnnouncement(id: $id) {
      ... on Viewer {
        id
      }
      ... on MutationError {
        errors {
          input
          inputErrors
        }
      }
    }
  }
`;

// AnnouncementModal.defaultProps = {};

// == Component ============================================================

export default function AnnouncementModal({ announcement }: IProps) {
  const { ctaText, ctaUrl, description, image, title } = announcement;
  const [dismissAnnouncementMutation] = useMutation<
    DismissAnnouncementMutation,
    DismissAnnouncementMutationVariables
  >(DISMISS_ANNOUNCEMENT_MUTATION);

  useEffect(() => {
    if (typeof $ !== "undefined") {
      $("#materialize-modal__announcement").modal({ dismissible: false });
      $("#materialize-modal__announcement").modal("open");
    }
  }, []);

  const onDismissClick = () => {
    dismissAnnouncementMutation({ variables: { id: announcement.id } }).catch(Bugsnag.notify);
    $("#materialize-modal__announcement").modal("close");
  };

  return (
    <div className="modal modal--small" id="materialize-modal__announcement">
      <Box p={3} textAlign="center">
        {!!image.large && <Image alt={title} display="block" mb={3} src={image.large} />}
        <Box mb={3}>
          <Text as="h2">{title}</Text>
          {!!description && (
            <Text display="block" lineHeight="copy" mt={1}>
              {description}
            </Text>
          )}
        </Box>
        {!!ctaText && (
          <Button
            as="a"
            display="block"
            href={ctaUrl}
            mb={2}
            target="_blank"
            variant="clear"
            width="100%"
            onClick={onDismissClick}
          >
            {ctaText}
          </Button>
        )}

        <Button display="block" width="100%" onClick={onDismissClick}>
          Okay, I Got It
        </Button>
      </Box>
    </div>
  );
}

// == Styles ===============================================================
